import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { NaturezaVendaNomePipe } from './natureza-venda-nome.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NaturezaVendaNomePipe
    ],
    exports: [
        NaturezaVendaNomePipe
    ],
    providers: [
        NaturezaVendaNomePipe
    ]
})
export class NaturezaVendaPipeModule { }
